import { getRegisteredQueryClient } from '~shared/lib/query-client-registry';

import { isNewUser } from './permission-checks';

import {
  getPrefetchedPermissions,
  getPrefetchedUserInfo,
} from '../api/get-prefetched-user-data';
import { type Permission } from '../entities/permissions';

export const getAnalyticsUserPermissions = (permissions: Permission[]) => {
  return isNewUser(permissions) ? 'NEW_PARTNER' : permissions.join(',');
};

type UserAmpliProps = {
  person_id?: string;
  role?: string;
};

export const getUserAmpliProps = (): UserAmpliProps | null => {
  const queryClient = getRegisteredQueryClient();

  if (!queryClient) {
    return null;
  }

  const userInfo = getPrefetchedUserInfo(queryClient);
  const permissions = getPrefetchedPermissions(queryClient);

  if (!userInfo || !permissions) {
    return null;
  }

  return {
    person_id: userInfo.personId,
    role: getAnalyticsUserPermissions(permissions),
  };
};
